export default {
  interviewMethod: '面试方式：',
  duration: '所需时间：',
  interviewTime: '面试时间：',
  meetingLink: '面试链接：',
  interviewLocation: '面试地址：',
  note: '备注：',
  availableTimeSlots: '可选面试时段：',
  mins: '分钟',
  interviewCancel: '面试邀请已取消',
  rejectButton: '拒绝面试邀请',
  rejectDialogButton: '提交',
  acceptButton: '接受面试邀请',
  acceptDialogButton: '提交',
  rejectMessage: '拒绝面试邀请',
  selectTimeWarning: '请先选择一个时间段',
  acceptMessage: '接受面试邀请，选择的时间：{time}',
  fetchError: '获取面试信息失败，请稍后重试',
  candidate: '候选人：',
  to: '至',
  accepted: '已接受面试邀请',
  rejected: '已拒绝面试邀请',
  expired: '面试邀请已过期',
  rejectionReason: '拒绝原因：',
  online: '线上',
  offline: '线下',
  interviewInvitation: '面试邀请',
  rejectSuccess: '已成功拒绝面试邀请',
  rejectError: '拒绝面试失败，请稍后重试',
  acceptSuccess: '已成功接受面试邀请',
  acceptError: '接受面试失败，请稍后重试',
  invalidTimeSlot: '无效的时间段',
  rejectDialogTitle: '拒绝面试邀请',
  rejectDialogLabel: '备注',
  rejectReasonPlaceholder: '拒绝原因',
  cancelButton: '取消',
  acceptDialogTitle: '接受面试邀请',
  defaultNote: '如不能按时参加，请提前告知',
  pleaseSelectInterviewer: '请选择面试官',
  pleaseSelectInterviewMethod: '请选择面试方式',
  pleaseEnterInterviewDuration: '请输入面试时长',
  pleaseEnterValidNumber: '请输入有效的数字',
  durationMustBeGreaterThanZero: '面试时长必须大于0',
  pleaseEnterInterviewAddress: '请输入面试地址',
  pleaseAddAtLeastOneTimeSlot: '请添加可选面试时段',
  pleaseCompleteAllTimeSlotInfo: '请完善可选面试时段信息',
  timeSlotMustNotBeLessThanDuration: '可选面试时段不能小于面试时长',
  pleaseEnterInterviewLink: '请输入面试链接',
  timeSlotExpired: '可选面试时已过期，请重新选择',
  noPermission: '无权限查看',
  needAgentConfirm: '等待猎头确认中',
};
